import React from "react";
import { GetRefund } from "../Components";

export const Refund = () => {
  return <GetRefund />;
};
